<div class="chat-width-a f-black">
    <div class="md-title f-big-ii roboto-b">
         Términos y Condiciones de la oferta
        <label class="ClaroTvTitle">Claro</label><label class="tvmasTitle">tv+</label>
        <img (click)="this.close()" class="xcloserevc" width="100%" src="../../assets/images/xtermclose.png">
    </div>
    <mat-dialog-content class="basicrow m-top f-s-14" style="padding-top: 10px;">
        <div class="grid">
            <div class="f-s-t">
                Términos y condiciones de oferta
            </div>
            <div [innerHTML]="this.offer.chvOfferTems"></div>
            <div class="f-w">
                IMPORTANTE: El servicio que ofrece Claro es para uso personal del cliente.
            </div>
            <div class="basicrow m-top f-reg roboto-b txt-center">
                Copyright © 2022 Puerto Rico Telephone Company, Inc.
            </div>
        </div>
    </mat-dialog-content>
</div>